import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  /**
   * L'INDIRIZZO WEB DEL FRONT-END, PER I COLLEGAMENTI DENTRO LE EMAIL.
   *
   * Non serve a noi: serve a **dirlo al server**. Va nell'header `baseEndpoint` di ogni chiamata
   * che fa partire un'email — benvenuto, invito, reimposta password, OTP — e il BE lo usa per
   * comporre i collegamenti assoluti.
   *
   * ⚠️ Su web non entra mai in gioco: `window.location.origin` e' l'indirizzo giusto per
   * definizione, domini personalizzati compresi. Conta **solo dentro l'app**, dove
   * nell'APK `APP/config.xml` dichiara `scheme`/`hostname`, quindi `window.location.origin`
   * non e' l'indirizzo del sito ma un'origine locale della WebView. Non e' un indirizzo
   * web, e siccome l'header **c'e' ed e' valorizzato** il ripiego del BE non scatta: chi chiede
   * la password nuova dal telefono riceve un collegamento a `https://localhost/...`.
   *
   * Vedi `baseEndpoint()` in `shared/lib/baseEndpoint.ts`.
   */
  VITE_FE_BASE_URL: z.string().url(),
  VITE_APP_NAME: z.string().min(1).default('MaeFwk10'),
  VITE_DEFAULT_LANG: z.string().default('it-IT'),
  /** Client id Google Identity Services: se assente il bottone "Accedi con Google" non compare. */
  VITE_GOOGLE_CLIENT_ID: z.string().optional(),
  /**
   * L'azienda a cui arrivano le richieste dalla **porta pubblica** dell'assistenza, e insieme
   * l'interruttore del collegamento «serve aiuto?» nella pagina d'accesso: vuoto = niente
   * collegamento.
   *
   * Sta qui e non nella configurazione del server perche' e' un fatto **dell'installazione**: la
   * pagina d'accesso e' una e le aziende sono molte, quindi a chi arrivano le richieste di chi
   * non e' ancora entrato lo decide chi mette su l'installazione.
   *
   * Non e' un segreto: l'identificativo compare nell'indirizzo che si manda ai clienti, e da solo
   * non apre niente.
   */
  VITE_PUBLIC_SUPPORT_TENANT_ID: z.string().optional().default(''),
});

const parsed = envSchema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('Invalid env config', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid env configuration');
}

export const env = parsed.data;
